/* tslint:disable */
import {
  Lease
} from '../index';

declare var Object: any;
export interface LeaseRenewTempInterface {
  "lease_id": number;
  "print_count": number;
  "email_sent_count": number;
  "lease_renew_obj": any;
  "type"?: string;
  "state"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  lease?: Lease;
}

export class LeaseRenewTemp implements LeaseRenewTempInterface {
  "lease_id": number;
  "print_count": number;
  "email_sent_count": number;
  "lease_renew_obj": any;
  "type": string;
  "state": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  lease: Lease;
  constructor(data?: LeaseRenewTempInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LeaseRenewTemp`.
   */
  public static getModelName() {
    return "LeaseRenewTemp";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LeaseRenewTemp for dynamic purposes.
  **/
  public static factory(data: LeaseRenewTempInterface): LeaseRenewTemp{
    return new LeaseRenewTemp(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LeaseRenewTemp',
      plural: 'LeaseRenewTemps',
      path: 'LeaseRenewTemps',
      idName: 'id',
      properties: {
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "print_count": {
          name: 'print_count',
          type: 'number',
          default: 0
        },
        "email_sent_count": {
          name: 'email_sent_count',
          type: 'number',
          default: 0
        },
        "lease_renew_obj": {
          name: 'lease_renew_obj',
          type: 'any'
        },
        "type": {
          name: 'type',
          type: 'string'
        },
        "state": {
          name: 'state',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        lease: {
          name: 'lease',
          type: 'Lease',
          model: 'Lease',
          relationType: 'belongsTo',
                  keyFrom: 'lease_id',
          keyTo: 'id'
        },
      }
    }
  }
}
